import PropTypes from "prop-types";
import StyleCount from "../../../../StyleCount";
import LoadPreviousButton from "../../../../LoadPrevious";
import RankingDisclaimer from "../../../../RankingDisclaimer";
import FilterAndSort from "../../../../../components/FilterAndSort";
import SelectedFacets from "../../../../../components/SelectedFacets";
import { useIsMobile } from "../../../../hooks";
import styles from "./ResultsHeader.css";

const ResultsHeader = ({ showLoadPrevious, itemCount }) => {
  const isMobile = useIsMobile();

  return showLoadPrevious ? (
    <>
      <span className={styles.filterRow}>
        <FilterAndSort />
        {!isMobile && <SelectedFacets />}
        <StyleCount itemCount={itemCount} />
      </span>
      {isMobile && (
        <span className={styles.row}>
          <SelectedFacets />
        </span>
      )}
      <LoadPreviousButton />
      <RankingDisclaimer />
    </>
  ) : (
    <>
      <span className={styles.filterRow}>
        <FilterAndSort />
        {!isMobile && <SelectedFacets />}
        <StyleCount itemCount={itemCount} />
      </span>
      {isMobile && (
        <span className={styles.row}>
          <SelectedFacets />
        </span>
      )}
      <RankingDisclaimer />
    </>
  );
};

ResultsHeader.propTypes = {
  itemCount: PropTypes.number.isRequired,
  showLoadPrevious: PropTypes.bool.isRequired,
};
export default ResultsHeader;
